<template>
  <main class="mt-0 main-content">
    <ToastPrime position="bottom-left"/>
    <section>
      <div class="page-header min-vh-100">
        <div class="container-fluid px-0">
          <div class="row g-0">
            <div
              class="col-6 d-lg-flex d-none h-100 my-auto ps-0 position-absolute top-0 start-0 text-center justify-content-center flex-column">
              <div
                class="position-relative h-100 m-3 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{
                  backgroundImage: `url(${apiUrl + '/gambar_login.jpg'})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }">
                <span class="mask bg-gradient-primary opacity-6"></span>
                <div class="position-relative z-index-1">
                  <h4 class="mt-5 text-white font-weight-bolder">
                    "Set a New Password"
                  </h4>
                  <p class="text-white px-5">
                    Lengkapi langkah terakhir untuk mengamankan kembali akun SmartCat Anda dengan kata sandi baru yang lebih kuat.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 offset-lg-6 d-flex align-items-center justify-content-center min-vh-100">
              <div class="card card-plain login-card shadow-lg bg-white">
                <div class="card-header pb-0 text-start bg-transparent border-0">
                  <h4 class="font-weight-bolder text-primary">Reset Password</h4>
                  <p class="mb-0">Enter your new password to reset your account</p>
                </div>
                <div class="card-body">
                  <div v-if="errorMessage.both" class="alert alert-danger" role="alert">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    {{ errorMessage.both }}
                  </div>

                  <div class="mb-3">
                    <div class="position-relative">
                      <input
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="New Password"
                        class="form-control"
                        :class="errorMessage.password ? 'border-danger' : ''"
                        :disabled="onLoading || verifyingToken || !tokenValid"
                        @keyup.enter="resetPassword"
                      />
                      <button
                        type="button"
                        class="btn btn-link position-absolute end-0 top-0"
                        style="z-index: 10;"
                        @click="togglePassword"
                      >
                        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                      </button>
                    </div>
                    <small v-if="errorMessage.password" class="text-danger">{{ errorMessage.password }}</small>
                  </div>
                  <div class="mb-3">
                    <div class="position-relative">
                      <input
                        v-model="confirmPassword"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        placeholder="Confirm New Password"
                        class="form-control"
                        :class="errorMessage.confirmPassword ? 'border-danger' : ''"
                        :disabled="onLoading || verifyingToken || !tokenValid"
                        @keyup.enter="resetPassword"
                      />
                      <button
                        type="button"
                        class="btn btn-link position-absolute end-0 top-0"
                        style="z-index: 10;"
                        @click="toggleConfirmPassword"
                      >
                        <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                      </button>
                    </div>
                    <small v-if="errorMessage.confirmPassword" class="text-danger">{{ errorMessage.confirmPassword }}</small>
                  </div>
                  <div class="text-center">
                    <argon-button
class="mt-4" variant="gradient" color="primary" full-width size="lg"
                      :disabled="onLoading || verifyingToken || !tokenValid" @click="resetPassword">
                      <span v-if="onLoading || verifyingToken">
                        <i class="fas fa-spinner fa-spin"></i>&nbsp;{{ verifyingToken ? 'Verifying...' : 'Please wait' }}
                      </span>
                      <span v-else>Reset Password</span>
                    </argon-button>
                  </div>

                  <div class="text-center mt-3">
                    <a href="/login" class="text-decoration-none">
                      <small class="text-muted">Back to Sign In</small>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import baseApiUrl from "@/configs/config";
import authService from "@/services/authService";
import api from "@/helpers/api";

const body = document.getElementsByTagName("body")[0];
body.classList.remove("bg-gray-100");

export default {
  components: {
    ArgonButton,
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      apiUrl: baseApiUrl.storageUrl,
      errorMessage: {
        password: "",
        confirmPassword: "",
        both: ""
      },
      onLoading: false,
      tokenValid: false,
      verifyingToken: true,
    };
  },
  watch: {
    password(newVal) {
      // Clear password error when user types
      if (newVal && this.errorMessage.password) {
        this.errorMessage.password = "";
      }
      // Clear confirm password error if passwords now match
      if (this.confirmPassword && newVal === this.confirmPassword && this.errorMessage.confirmPassword) {
        this.errorMessage.confirmPassword = "";
      }
    },
    confirmPassword(newVal) {
      // Clear confirm password error when user types
      if (newVal && this.errorMessage.confirmPassword) {
        this.errorMessage.confirmPassword = "";
      }
      // Clear password error if passwords now match
      if (this.password && this.password === newVal && this.errorMessage.password) {
        this.errorMessage.password = "";
      }
    }
  },
  mounted() {
    this.$store.commit("argonConfig/toggleDefaultLayout");
    
    // Get token and email from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get('token');
    this.email = urlParams.get('email');
    
    // Validate token and email presence
    if (!this.token || !this.email) {
      this.errorMessage.both = "Invalid reset link. Please request a new password reset.";
      this.verifyingToken = false;
    } else {
      // Verify token first
      this.verifyToken();
    }
  },
  methods: {
    async resetPassword() {
      this.errorMessage = {
        password: "",
        confirmPassword: "",
        both: ""
      };

      // Validate token and email
      if (!this.token || !this.email) {
        this.errorMessage.both = "Invalid reset link. Please request a new password reset.";
        return false;
      }

      // Validate token is still valid
      if (!this.tokenValid) {
        this.errorMessage.both = "Invalid or expired reset link. Please request a new password reset.";
        return false;
      }

      // Validate password
      if (this.password.trim() === "") {
        this.errorMessage.password = "Password is required";
        return false;
      }

      if (this.password.length < 8) {
        this.errorMessage.password = "Password must be at least 8 characters long";
        return false;
      }

      // Validate confirm password
      if (this.confirmPassword.trim() === "") {
        this.errorMessage.confirmPassword = "Please confirm your password";
        return false;
      }

      if (this.password !== this.confirmPassword) {
        this.errorMessage.confirmPassword = "Passwords do not match";
        return false;
      }

      this.onLoading = true;

      try {
        await api(this, authService.resetPassword({
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword
        }), true);
        
        // Redirect to login page after successful reset with success message
        window.location.href = '/login?reset=success';
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.errorMessage.both = error.response.data.message;
        } else if (error.message) {
          this.errorMessage.both = error.message;
        } else {
          this.errorMessage.both = "An error occurred while resetting your password.";
        }
      } finally {
        this.onLoading = false;
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    async verifyToken() {
      try {
        const response = await api(this, authService.verifyResetToken({
          token: this.token,
          email: this.email
        }), false);
        
        if (response.data && response.data.valid) {
          this.tokenValid = true;
        } else {
          this.errorMessage.both = "Invalid or expired reset link. Please request a new password reset.";
        }
      } catch (error) {
        this.errorMessage.both = "Invalid or expired reset link. Please request a new password reset.";
      } finally {
        this.verifyingToken = false;
      }
    },
  },
};
</script>

<style scoped>
.login-card {
  background: white !important;
  border-radius: 1.25rem !important;
  width: 100%;
  max-width: 520px;
  padding: 2.5rem 2rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05) !important;
}

.form-control {
  padding: 0.75rem 1rem;
}
</style> 